import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatNativeDateModule} from '@angular/material/core';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSidenavModule} from '@angular/material/sidenav';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTableModule} from '@angular/material/table';
import {MatSelectModule} from '@angular/material/select';
import {MatSliderModule} from '@angular/material/slider';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatRadioModule} from '@angular/material/radio';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatMenuModule} from '@angular/material/menu';
import {MatTabsModule} from '@angular/material/tabs';
import {MatListModule} from '@angular/material/list';
import {MatTreeModule} from '@angular/material/tree';
import {MatStepperModule} from '@angular/material/stepper';
import {MatChipsModule} from '@angular/material/chips';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        MatButtonModule,
        MatCheckboxModule,
        MatGridListModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatSidenavModule,
        MatCardModule,
        MatIconModule,
        MatTooltipModule,
        MatTableModule,
        MatSelectModule,
        MatSliderModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        MatDialogModule,
        MatButtonToggleModule,
        MatToolbarModule,
        MatMenuModule,
        MatTabsModule,
        MatListModule,
        MatTreeModule,
        MatStepperModule,
        MatProgressBarModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatInputModule
    ],
    declarations: [],
    exports: [
        MatButtonModule,
        MatCheckboxModule,
        MatGridListModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        MatSidenavModule,
        MatCardModule,
        MatIconModule,
        MatTooltipModule,
        MatTableModule,
        MatSelectModule,
        MatSliderModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        MatDialogModule,
        MatButtonToggleModule,
        MatToolbarModule,
        MatMenuModule,
        MatTabsModule,
        MatListModule,
        MatTreeModule,
        MatStepperModule,
        MatProgressBarModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatInputModule
    ]
})
export class MaterialDesignModule {
}
